export const leftItemsName = 'leftItemsComponent';
